import React, { createContext, useContext, useEffect, useState } from "react";
import { ADSENSE_CLIENT, AD_SLOTS, adsConfigured, loadAdSense } from "../lib/ads";

const AdsContext = createContext(null);

export function AdsProvider({ children }) {
  const client = ADSENSE_CLIENT;
  const enabled = adsConfigured();
  const [consent, setConsentState] = useState(() => localStorage.getItem("de_ads_consent"));
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (enabled && client) {
      loadAdSense(client);
      setReady(true);
    }
  }, [enabled, client]);

  const setConsent = (v) => {
    localStorage.setItem("de_ads_consent", v);
    setConsentState(v);
  };

  return (
    <AdsContext.Provider
      value={{ client, slots: AD_SLOTS, enabled, consent, setConsent, ready }}
    >
      {children}
    </AdsContext.Provider>
  );
}

export function useAds() {
  const ctx = useContext(AdsContext);
  if (!ctx) throw new Error("useAds must be used within AdsProvider");
  return ctx;
}
